import { BodyPart } from "@/types/design";
import {
	INITIAL_BACK_HAIR_STYLE,
	INITIAL_EYES_STYLE,
	INITIAL_EYEBROWS_STYLE,
	INITIAL_HAIR_STYLE,
	INITIAL_MOUTH_STYLE,
	INITIAL_PREVIEW_EYELINE_STYLE,
} from "./initialPartStyle";

const INITIAL_BODY: BodyPart[] = [
	{
		partName: "hair",
		partId: undefined,
		partStyle: INITIAL_HAIR_STYLE,
		partComponent: undefined,
	},
	{
		partName: "backHair",
		partId: undefined,
		partStyle: INITIAL_BACK_HAIR_STYLE,
		partComponent: undefined,
	},
	{
		partName: "eyebrows",
		partId: undefined,
		partStyle: INITIAL_EYEBROWS_STYLE,
		partComponent: undefined,
	},
	{
		partName: "eyeline",
		partId: undefined,
		partStyle: INITIAL_PREVIEW_EYELINE_STYLE,
		partComponent: undefined,
	},
	{
		partName: "eyes",
		partId: undefined,
		partStyle: INITIAL_EYES_STYLE,
		partComponent: undefined,
	},
	{
		partName: "mouth",
		partId: undefined,
		partStyle: INITIAL_MOUTH_STYLE,
		partComponent: undefined,
	},
];

export { INITIAL_BODY };
